import React from 'react';

/**
 * Cella identità per le colonne dei DataGrid (come `.cell-id` del mockup mbility-gestionale):
 * avatar quadrato colorato + nome forte + sottotitolo muted.
 *
 * Props:
 * - avatar:  stringa (iniziali) o nodo (icona)
 * - title:   testo principale
 * - subtitle: testo secondario muted
 * - tint:    'navy' (default) | 'teal' | 'purple'
 */
export default function AvatarCell({ avatar, title, subtitle, tint = 'navy' }) {
  const tintClass =
    tint === 'teal' ? 'avatar-sq--teal' : tint === 'purple' ? 'avatar-sq--purple' : '';
  return (
    <div className="cell-id">
      <div className={`avatar-sq ${tintClass}`} aria-hidden="true">
        {avatar}
      </div>
      <div className="cell-id__text">
        <div className="cell-strong">{title}</div>
        {subtitle ? <div className="cell-muted">{subtitle}</div> : null}
      </div>
    </div>
  );
}
